module.exports = __webpack_public_path__ + "img/file-folder.7a7a7e42.svg";